// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const getCookieValuesFromRequest = (request, cookieNames) => {
    const cookieHeader = request.headers.get('Cookie');
    if (!cookieHeader) {
        return {};
    }
    const cookieValues = cookieHeader
        .split(';')
        .map(cookie => cookie.trim().split('='))
        .reduce((result, [key, value]) => {
        result[key] = value;
        return result;
    }, {});
    const result = {};
    for (const cookieName of cookieNames) {
        result[cookieName] = cookieValues[cookieName];
    }
    return result;
};

export { getCookieValuesFromRequest };
//# sourceMappingURL=getCookieValuesFromRequest.mjs.map
